module.exports = __webpack_public_path__ + "1c96d3ea3d51bcc0190e6bb7c5d6e4a9.png";